import {
  DisplayContent,
  ItemAppearance,
  LayoutType,
  OpenQuestionIcon,
} from '../components/FaqOoi/settingsParams';
import { PresetSettings } from '../types/designTypes';
import { CategoriesPosition } from '../enums';

export const presetToLayoutMap: Record<
  PresetSettings,
  {
    layout: LayoutType;
    categoriesPosition: CategoriesPosition;
    itemAppearance: ItemAppearance;
    openQuestionIcon: OpenQuestionIcon;
  }
> = {
  [PresetSettings.ACCORDION_TOP_CATEGORIES]: {
    layout: LayoutType.Collapse,
    categoriesPosition: CategoriesPosition.TOP,
    itemAppearance: ItemAppearance.BOX,
    openQuestionIcon: OpenQuestionIcon.ARROW,
  },
  [PresetSettings.ACCORDION_SIDE_CATEGORIES]: {
    layout: LayoutType.Collapse,
    categoriesPosition: CategoriesPosition.SIDE,
    itemAppearance: ItemAppearance.BOX,
    openQuestionIcon: OpenQuestionIcon.ARROW,
  },
  [PresetSettings.NUMERIC_SIDE_CATEGORIES]: {
    layout: LayoutType.Stripes,
    categoriesPosition: CategoriesPosition.SIDE,
    itemAppearance: ItemAppearance.BOX,
    openQuestionIcon: OpenQuestionIcon.PLUSCIRCLE,
  },
  [PresetSettings.NUMERIC_TOP_CATEGORIES]: {
    layout: LayoutType.Stripes,
    categoriesPosition: CategoriesPosition.TOP,
    itemAppearance: ItemAppearance.BOX,
    openQuestionIcon: OpenQuestionIcon.ARROW,
  },
  [PresetSettings.LIST_TOP_CATEGORIES]: {
    layout: LayoutType.Basic,
    categoriesPosition: CategoriesPosition.TOP,
    itemAppearance: ItemAppearance.NONE,
    openQuestionIcon: OpenQuestionIcon.ARROW,
  },

  [PresetSettings.LIST_SIDE_CATEGORIES]: {
    layout: LayoutType.Basic,
    categoriesPosition: CategoriesPosition.SIDE,
    itemAppearance: ItemAppearance.NONE,
    openQuestionIcon: OpenQuestionIcon.ARROW,
  },
  [PresetSettings.LINES_TOP_CATEGORIES]: {
    layout: LayoutType.Collapse,
    categoriesPosition: CategoriesPosition.TOP,
    itemAppearance: ItemAppearance.BOX,
    openQuestionIcon: OpenQuestionIcon.ARROW,
  },
  [PresetSettings.LINES_SIDE_CATEGORIES]: {
    layout: LayoutType.Collapse,
    categoriesPosition: CategoriesPosition.SIDE,
    itemAppearance: ItemAppearance.BOX,
    openQuestionIcon: OpenQuestionIcon.ARROW,
  },
};
